import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { DashboardComponent } from './manage/dashboard/dashboard.component';
import { SchoolComponent } from './theme/school.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: SchoolComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: 'yonetim', data: { breadcrumb: 'Ana Sayfa', roles: ['ADMIN'] }, loadChildren: () => import('./manage/manage.module').then(m => m.ManageModule) },
      { path: 'ogrenci', data: { breadcrumb: 'Ana Sayfa', roles: ['STUDENT'] }, loadChildren: () => import('./student/student.module').then(m => m.StudentModule) },
      { path: 'egitmen', data: { breadcrumb: 'Ana Sayfa', roles: ['INSTRUCTOR'] }, loadChildren: () => import('./instructor/instructor.module').then(m => m.InstructorModule) },
      { path: 'tenant', data: { breadcrumb: 'Müşteri Yönetimi', roles: ['PERASIS'] }, loadChildren: () => import('./tenant/tenant.module').then(m => m.TenantModule) },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SchoolRoutingModule { }
